import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if (flag) {
	var isPhone = true;
} else {
	var isPhone = false;
}

const pc_routes = [
	{
		path: '/',
		name: 'index',
		component: () => import('@/views/pc/index'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/page',
		name: 'page',
		component: () => import('@/views/pc/page'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/activity',
		name: 'activity',
		component: () => import('@/views/pc/activity'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/search',
		name: 'search',
		component: () => import('@/views/pc/search'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/detail',
		name: 'detail',
		component: () => import('@/views/pc/detail'),
		meta: {
			keepAlive: false
		}
	},
    {
		path: '/match',
		name: 'match',
		component: () => import('@/views/pc/match'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '*',
		name: 'exp404',
		component: () => import('@/views/pc/exp404'),
		meta: {
			keepAlive: true
		}
	},
];

const wap_routes = [
	{
		path: '/',
		name: 'index',
		component: () => import('@/views/wap/index'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/page',
		name: 'page',
		component: () => import('@/views/wap/page'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/activity',
		name: 'activity',
		component: () => import('@/views/wap/activity'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/search',
		name: 'search',
		component: () => import('@/views/wap/search'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/detail',
		name: 'detail',
		component: () => import('@/views/wap/detail'),
		meta: {
			keepAlive: false
		}
	},
    {
		path: '/match',
		name: 'match',
		component: () => import('@/views/wap/match'),
		meta: {
			keepAlive: false
		}
	},
	{
		path: '*',
		name: 'exp404',
		component: () => import('@/views/wap/exp404'),
		meta: {
			keepAlive: true
		}
	},
];

const router = new VueRouter({
	mode: 'history',
	routes:!isPhone?pc_routes:wap_routes,
})
router.beforeEach((to, from, next) => {	
	next();
})
export default router
